import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

// the root, initial state object
const moduleLayers = {
  state: {
    map: null,
    list: [],
    activeLayers: []
  },
  // define the possible mutations that can be applied to our state
  mutations: {
    SET_MAP (state, map) {
      state.map = map;
    },
    DELETE_MAP (state) {
      state.map = null;
    },
    ADD_LAYER (state, layer) {
      state.list.push(layer);
      state.map.addLayer(layer.layer);
      state.activeLayers.push(layer);
    },
    // DELETE_NOTE (state) {
    //   state.list.$remove(state.activeElement)
    //   state.activeElement = state.list[0]
    // },
    TOGGLE_LAYER (state, layer) {
      var index = state.activeLayers.indexOf(layer);
      if (index >= 0) {
        state.activeLayers.splice(index, 1);
        // layer.hide()
        state.map.removeLayer(layer);
      } else {
        state.activeLayers.push(layer);
        state.map.addLayer(layer);
        // layer.show()
      }
    }
  },
  getters: {
    map (state) {
      return state.map;
    },
    allLayers (state) {
      return state.list;
    },
    activeLayers (state) {
      return state.activeLayers;
    }
  }
};

const moduleEditUser = {
  // the root, initial state object
  state: {
    userEdit: {}
  },
  // define the possible mutations that can be applied to our state
  mutations: {
    SET_USER (state, element) {
      state.userEdit = element;
    }
  },
  getters: {
    user2Edit (state) {
      return state.userEdit;
    }
  }
};

// create the Vuex instance by combining the state and mutations objects
// then export the Vuex store for use by our components
export default new Vuex.Store({
  modules: {
    layers: moduleLayers,
    note: moduleEditUser
  }
});



// WEBPACK FOOTER //
// ./src/vuex/store.js